import React, { memo } from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function PublisherStatement() {
  return <section className="py-20 md:py-28 px-6 bg-base" data-id="element-543">
      <div className="max-w-copy mx-auto" data-id="element-544">
        {/* Section label */}
        <FadeIn data-id="element-545">
          <div className="flex items-center gap-4 mb-16" data-id="element-546">
            <div className="h-px bg-border-accent flex-grow" data-id="element-547" />
            <span className="font-ui text-xs font-semibold tracking-widest uppercase text-accent-primary" data-id="element-548">
              ◆ Publisher's Note ◆
            </span>
            <div className="h-px bg-border-accent flex-grow" data-id="element-549" />
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-550">
          <h2 className="font-display text-3xl md:text-5xl font-bold text-text-primary mb-14 text-center leading-tight" data-id="element-551">
            Why We Published It
          </h2>
        </FadeIn>

        {/* Statement body — styled as a formal note */}
        <FadeIn delay={0.2} data-id="element-552">
          <div className="bg-surface border border-border-default rounded-sm p-8 md:p-12" data-id="element-553">
            <div className="space-y-8 font-body text-lg leading-relaxed text-text-secondary" data-id="element-554">
              <p data-id="element-555">
                We believe certain stories deserve to be preserved with the same
                care a library gives its archives.
              </p>

              <p className="font-display text-xl md:text-2xl font-bold text-text-primary py-2" data-id="element-556">
                This memorial was not published with an agenda. It was published
                because memory has value.
              </p>

              <p data-id="element-557">
                This book was edited, designed, and distributed as what it is: a
                high-value documentary piece for readers who take seriously the
                history they are living through.
              </p>

              <p data-id="element-558">
                Every chapter was fact-checked, every timeline verified, every
                perspective weighed. Not to tell you what to think — but to give
                you everything you need to think clearly.
              </p>
            </div>

            {/* Attribution */}
            <div className="mt-10 pt-8 border-t border-border-default" data-id="element-559">
              <p className="font-ui text-xs font-semibold tracking-widest uppercase text-accent-muted" data-id="element-560">
                The Editorial Team
              </p>
              <p className="font-display text-base italic text-text-secondary mt-1" data-id="element-561">
                Better Library Publishing
              </p>
            </div>
          </div>
        </FadeIn>

        {/* Closing quote */}
        <FadeIn delay={0.3} data-id="element-562">
          <div className="border-l-4 border-accent-primary bg-surface p-6 md:p-8 mt-14" data-id="element-563">
            <p className="font-display text-xl md:text-2xl italic text-text-primary leading-relaxed m-0" data-id="element-564">
              "When the noise fades, the books remain.
              <br data-id="element-565" />
              This is one of those books."
            </p>
          </div>
        </FadeIn>

        {/* CTA */}
        <FadeIn delay={0.4} data-id="element-566">
          <div className="flex flex-col items-center mt-12 text-center" data-id="element-567">
            <Button href="#offer" variant="secondary" className="w-full md:w-auto text-sm md:text-base" data-id="element-568">
              Read The Full Memorial &rarr;
            </Button>
          </div>
        </FadeIn>
      </div>
    </section>;
}